class ImageBannerSlider extends HTMLElement {
  constructor() {
    super();
    this.embla = null;
    this.autoplayTimeout = null;
    this.isAutoplayRunning = false;
  }

  connectedCallback() {
    this.initSlider();
  }

  disconnectedCallback() {
    this.destroySlider();
  }

  initSlider() {
    if (typeof EmblaCarousel === 'undefined') {
      setTimeout(() => this.initSlider(), 100);

      return;
    }

    const viewport = this.querySelector('.image-banner-slider__viewport');

    if (!viewport) {
      return;
    }

    const dots = this.querySelectorAll('.image-banner-slider__dot');
    const autoplay = this.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;

    this.embla = EmblaCarousel(viewport, {
      loop: true,
      align: 'start',
      duration: 25
    });

    const triggerDotAnimation = (index) => {
      dots.forEach((dot, idx) => {
        const progress = dot.querySelector('.image-banner-slider__dot-progress');
        if (!progress) {
          return;
        }

        progress.style.transition = 'none';

        if (idx < index) {
          progress.style.width = '100%';
        } else if (idx > index) {
          progress.style.width = '0%';
        } else {
          progress.style.width = '0%';

          if (autoplay && this.isAutoplayRunning) {
            progress.offsetHeight;
            progress.style.transition = `width ${autoplaySpeed}ms linear`;
            progress.style.width = '100%';
          } else {
            progress.style.width = '100%';
          }
        }
      });
    };

    const updateDots = () => {
      const selectedIndex = this.embla.selectedScrollSnap();

      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === selectedIndex);
      });

      triggerDotAnimation(selectedIndex);
    };

    this.embla.on('select', () => {
      updateDots();

      if (autoplay && this.isAutoplayRunning) {
        this.resetAutoplay(autoplaySpeed);
      }
    });

    this.embla.on('init', updateDots);

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.embla.scrollTo(index);

        if (autoplay) {
          this.resetAutoplay(autoplaySpeed);
        }
      });
    });

    const slides = this.querySelectorAll('.image-banner-slider__slide');

    slides.forEach((slide) => {
      let pointerStartX = 0;
      let pointerStartY = 0;

      slide.addEventListener('pointerdown', (event) => {
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
      });

      slide.addEventListener('click', (event) => {
        const interactiveElement = event.target.closest('a, button, [role="button"], select, input, textarea, .video-controls-banner, .video-play-pause-control, .video-sound-control');

        if (interactiveElement) {
          return;
        }

        const deltaX = Math.abs(event.clientX - pointerStartX);
        const deltaY = Math.abs(event.clientY - pointerStartY);

        if (deltaX < 10 && deltaY < 10) {
          this.embla.scrollNext();
        }
      });
    });

    const startAutoplay = () => {
      this.isAutoplayRunning = true;

      triggerDotAnimation(this.embla.selectedScrollSnap());

      this.autoplayTimeout = setTimeout(() => {
        if (this.embla) {
          if (this.embla.canScrollNext()) {
            this.embla.scrollNext();
          } else {
            this.embla.scrollTo(0);
          }
        }
      }, autoplaySpeed);
    };

    this.stopAutoplay = () => {
      this.isAutoplayRunning = false;

      if (this.autoplayTimeout) {
        clearTimeout(this.autoplayTimeout);

        this.autoplayTimeout = null;
      }

      triggerDotAnimation(this.embla.selectedScrollSnap());
    };

    this.resetAutoplay = () => {
      if (this.autoplayTimeout) {
        clearTimeout(this.autoplayTimeout);

        this.autoplayTimeout = null;
      }

      startAutoplay();
    };

    if (autoplay) {
      startAutoplay();
    }

    this.addEventListener('shopify:block:select', (event) => {
      const selectedBlock = event.target;
      const slidesArray = Array.from(this.querySelectorAll('.image-banner-slider__slide'));
      const index = slidesArray.indexOf(selectedBlock);

      if (index > -1 && this.embla) {
        this.stopAutoplay();
        this.embla.scrollTo(index);
      }
    });

    this.addEventListener('shopify:block:deselect', () => {
      if (autoplay) {
        this.resetAutoplay();
      }
    });
  }

  destroySlider() {
    if (this.autoplayTimeout) {
      clearTimeout(this.autoplayTimeout);
    }

    if (this.embla) {
      this.embla.destroy();
      this.embla = null;
    }
  }
}

if (!customElements.get('image-banner-slider')) {
  customElements.define('image-banner-slider', ImageBannerSlider);
}
